import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

  import { useRouter } from 'vue-router/composables'
  import useI18n from '@/composables/useI18n'
  import useCommonMixin from '@/composables/useCommonMixin'

  import type { PropType } from 'vue'
  import type { CourseExamResult } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExamResultsCompletions',
  props: {
    fetchingCompletionResults: {
      type: Boolean,
      required: true,
    },
    fetchedAllCompletions: {
      type: Boolean,
      required: true,
    },
    examResults: {
      type: Array as PropType<CourseExamResult[]>,
      required: true,
    },
  },
  emits: ['fetch-more-completion-results'],
  setup(__props) {

  const router = useRouter()
  const { translateString } = useI18n()
  const { formatDate } = useCommonMixin()

  const fetchingMoreCompletionResults = ref(false)

  

  

  const showCompletionStatus = computed(() => {
    return (completion: CourseExamResult) => {
      const performedStatus = completion.passed
        ? translateString('courses.examSimulation.passed')
        : translateString('courses.examSimulation.failed')

      const allScores: string[] = []

      completion.parts.forEach((part) => {
        part.subjects.forEach((subject) => {
          allScores.push(`${subject.score}%`)
        })
      })
      return `${formatDate(completion.performedDate, 'dd.MM.yyyy')}: ${performedStatus} (${allScores.toString()})`
    }
  })

  const routeToResults = (completionId: string) => {
    router.push({ name: 'CourseExamResults', params: { completionId } })
  }

return { __sfc: true,router, translateString, formatDate, fetchingMoreCompletionResults, showCompletionStatus, routeToResults, computed, ref, LoadingSpinner, useRouter, useI18n, useCommonMixin }
}

})